import * as jwt from 'jsonwebtoken';
export const signToken = (data: any, secret: string): string => {
  let token = jwt.sign(data, secret);
  return token;
};

export const verifyToken = async (token: string,secret: string): Promise<any> =>{
  try {
    let decodedData = jwt.verify(token,secret);
    return decodedData;
  } catch (error) {
    return {
        success: false,
        data: null,
    }
  }
}
